module.exports = __webpack_public_path__ + "img/sgbci.7155544d.png";